module.exports = __webpack_public_path__ + "img/img3.cc2b0d57.png";